export type { SliderCardProps } from "./slider-card";
export { SliderCard } from "./slider-card";
